<template>
  <div>
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center pb-2">
        <SectionTitle>
          身長体重管理
        </SectionTitle>
      </div>
      <CollapseButton
        :open="isCollapseOpen"
        @click="isCollapseOpen = !isCollapseOpen" />
    </div>
    <b-collapse
      :visible="isCollapseOpen">
      <div
        class="d-flex flex-column"
        style="gap: 8px;">
        <BodyMeasurementItem
          v-for="bodyMeasurement in bodyMeasurements"
          :key="bodyMeasurement.id"
          :can-edit="canEdit"
          :body-measurement="bodyMeasurement"
          :user-id="userId" />
      </div>
    </b-collapse>
    <LinkButton
      v-if="canEdit"
      class="my-2"
      :to="`/members/${userId}/profile/body_measurements/add`">
      <RoundedIcon
        class="mr-2"
        color="l-blue"
        icon="add" />
      記録する学年を追加
    </LinkButton>
  </div>
</template>

<script>
import LinkButton from '@/components/parts/LinkButton.vue'
import RoundedIcon from '@/components/parts/RoundedIcon.vue'
import SectionTitle from '@/components/view/profile/SectionTitle.vue'
import CollapseButton from '@/components/view/profile/CollapseButton.vue'
import BodyMeasurementItem from '@/components/view/profile/body_measurements/BodyMeasurementItem.vue'
export default {
  components: {
    SectionTitle,
    CollapseButton,
    BodyMeasurementItem,
    LinkButton,
    RoundedIcon,
  },
  props: {
    canEdit: {
      type: Boolean,
      required: true,
    },
    userId: {
      type: String,
      required: true,
    },
    bodyMeasurements: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isCollapseOpen: true,
    }
  },
}
</script>

<style>

</style>